import { AfterViewInit, Directive, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { FormConstructorComponent } from 'src/app/forms/form-constructors/form-constructor/form-constructor.component';
import { FormConstructorContent } from 'src/app/interfaces/form-and-field.interface';
import { AddFormDataToSaveContent, ProfileFormValue } from 'src/app/interfaces/profile.interface';

@Directive()
export abstract class UserTypeState implements AfterViewInit {
  @Input({ required: true }) public formsContent: FormConstructorContent[] = [];
  @Input({ required: true }) public isAdminSession: boolean;

  @Output() public saveUserType: EventEmitter<ProfileFormValue[]> = new EventEmitter<ProfileFormValue[]>();
  @Output() public userComponentInitiated: EventEmitter<QueryList<FormConstructorComponent>> = new EventEmitter<
    QueryList<FormConstructorComponent>
  >();

  @ViewChildren(FormConstructorComponent) public userTypeForms: QueryList<FormConstructorComponent>;

  public someInvalidForms: boolean[] = [];

  public ngAfterViewInit(): void {
    this.userComponentInitiated.emit(this.userTypeForms);
  }

  public saveUserTypeChanges(): void {
    this.someInvalidForms = [];
    const formsValue: ProfileFormValue[] = [];

    if (this.userTypeForms.length > 0 || this.isAdminSession) {
      this.userTypeForms.forEach((roleForm: FormConstructorComponent, id: number) => {
        this.someInvalidForms.push(roleForm.childForm.isFormValid());
        if (roleForm.childForm.isFormValid()) {
          this.addFormDataToSave({ roleForm, formsValue, id });
        }
      });

      this.saveFormsChanges(formsValue);
    }
  }

  private addFormDataToSave(content: AddFormDataToSaveContent): void {
    content.roleForm.prepareSubmitData();

    content.formsValue.push({
      formType: this.formsContent[content.id].formAttribute.type,
      formValue: content.roleForm.formContent.data,
    });
  }

  private saveFormsChanges(formsValue: ProfileFormValue[]): void {
    if (formsValue.length === this.formsContent.length) {
      this.saveUserType.emit(formsValue);
    }
  }
}
